import { render, staticRenderFns } from "./GameImagePlaceholder.vue?vue&type=template&id=3ab22773&scoped=true&"
import script from "./GameImagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./GameImagePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./GameImagePlaceholder.vue?vue&type=style&index=0&id=3ab22773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab22773",
  null
  
)

export default component.exports